<!-- eslint-disable max-len -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="25"
    width="25"
    viewBox="-5 -1 34 27"
    xml:space="preserve"
  >
    <path
      :fill="pathFill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M 2.346,17.307 L 5.253,20.276 L 3.779,21.688 L 0.872,18.740 L 0.914,18.657 Z M 8.098,11.804 L 10.963,14.711 L 8.430,17.245 L 5.793,19.757 L 2.928,16.850 L 2.907,16.788 L 5.419,14.441 Z M 22.861,11.451 L 23.920,12.614 L 21.865,14.504 L 20.806,13.424 L 20.785,13.362 L 22.674,11.576 Z M 10.071,9.832 L 12.936,12.718 L 11.524,14.130 L 11.483,14.130 L 8.638,11.244 Z M 12.957,8.627 L 14.161,9.853 L 12.728,11.265 L 11.524,10.060 L 11.524,10.019 Z M 20.847,8.233 L 22.176,10.828 L 22.176,10.891 L 20.245,12.718 L 20.162,12.760 L 17.670,11.389 L 17.504,11.265 Z M 16.445,3.540 L 16.487,3.540 L 20.411,7.465 L 16.653,10.912 L 12.770,7.029 Z M 17.047,2.627 L 16.757,2.461 L 16.591,2.419 L 16.196,2.440 L 15.864,2.606 L 11.773,6.613 L 11.649,6.883 L 11.649,7.195 L 11.690,7.340 L 11.773,7.485 L 12.355,8.088 L 10.963,9.458 L 10.922,9.458 L 10.527,9.064 L 10.278,8.939 L 9.842,8.939 L 9.572,9.084 L 4.464,14.151 L 0.145,18.283 L 0.000,18.594 L 0.000,18.864 L 0.145,19.176 L 3.322,22.415 L 3.613,22.560 L 3.924,22.560 L 4.215,22.415 L 9.344,17.494 L 13.704,13.216 L 13.829,13.009 L 13.850,12.905 L 13.829,12.490 L 13.663,12.199 L 13.310,11.846 L 14.722,10.434 L 16.051,11.701 L 17.463,12.427 L 19.664,13.673 L 21.304,15.272 L 21.657,15.459 L 22.010,15.459 L 22.363,15.272 L 24.834,13.050 L 24.979,12.780 L 24.979,12.386 L 24.917,12.240 L 24.419,11.659 L 23.048,10.226 L 21.387,6.987 Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    pathFill: {
      type: String,
      default: '#FFFFFF',
    },
  },
};
</script>
